<template>
  <!-- :visible.sync="vis" -->
  <el-dialog
    :title="$t('输入6位资金密码')"
    :visible="value"
    :custom-class="currentLangType() === 'en' ? 'dialog_six' : ''"
    width="420px"
    top="130px"
    :modal="false"
    center
    :close-on-click-modal="false"
    @update:visible=";(validationCode = []), $emit('input', $event)"
  >
    <div class="verify_input_box">
      <VerifyInput
        :code="validationCode"
        @input="handleInput"
        type="password"
      ></VerifyInput>
    </div>
  </el-dialog>
</template>
<script>
import currentLangType from '@/utils/currentLangType'
export default {
  name: 'TradingPassDialog',
  props: {
    value: Boolean
  },
  data() {
    return {
      validationCode: [],
      codeString: ''
    }
  },
  methods: {
    currentLangType,
    handleInput(array) {
      if (array.length === 6) {
        this.validationCode = []
        this.$emit('trading', array.join(''))
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  border-radius: 20px;
  .el-dialog__header {
    padding: 38px 40px 0 40px;
    .el-dialog__title {
      display: inline-block;
      height: 42px;
      font-size: 30px;
      font-weight: 500;
      font-family: PingFangSC-Medium, 'PingFang SC';
      color: rgba(51, 51, 51, 1);
      line-height: 42px;
    }
  }
  .el-dialog__body {
    padding: 40px;

    .verify_input_box {
      margin-top: 30px;
    }
  }
}

// 语言为英语时，进行样式微调
/deep/ .dialog_six {
  .el-dialog__header {
    .el-dialog__title {
      font-size: 23px;
    }
  }
  .el-dialog__body {
    .input_tips {
      font-size: 15px;
    }
  }
}
</style>
